<template>
<!-- 	<div>
		<div v-if="loading">
			<Loader />
		</div> -->
		<div class="box search-properties" v-else>
			<!-- val: {{ value }} -->
			<Select :value="value" :list="clients" emit="clientChosen" />
		</div>
<!-- 	</div> -->
</template>

<script>

	import {mapGetters} from 'vuex';
	import Loader from './Loader.vue';
	import Select from './Select.vue';

	export default {
		props: [
			'value'
		],
		data: () => ({
			loading: true,
			clients: []
		}),
		computed: {
			...mapGetters([
				'getToken'
			])
		},
		components: {
			Loader,
			Select
		},
		methods: {
			load() {
				axios({
                    method: 'GET',
                    url: window.config.apiUrl + 'api/client',

                }).then(response => {
                	this.clients = response.data;
                	this.loading = false;
                });
			}
		},
		created() {
			this.load();
		}
	}
</script>
